// safe new design
import {memo} from 'react';

import styled, {css, DefaultTheme, FlattenInterpolation, ThemeProps} from 'styled-components';

import {ReorderDropdown} from '~/reorder';
import TenbisForBusiness from '~/shared/components/TenbisForBusiness';
import {HeaderAllowedFeatures} from '~/shared/components/header/types';
import {media} from '~/shared/theme/media';
import {flexCenter} from '~/shared/theme/FlexLayout';

import Logo from '../Logo';

import LanguageAndUserMenu from './LanguageAndUserMenu';
import AddressDropdown from './AddressDropdown';

const HeaderWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const AddressDropdownWrapper = styled.div<{isLoggedIn: boolean}>`
  display: flex;
  flex: 1;
  padding: 0 ${({isLoggedIn}) => (isLoggedIn ? 20 : 16)}px;
  ${media.minLargeMobile`
    padding: 0 24px;
  `}
  ${media.minLargeDesktop`
    padding: 0 40px;
  `}
`;

const userMenusDefaultStyles = css`
  ${media.minLargeTablet`
    gap: 48px;
  `}
  ${media.minLargeDesktop`
    gap: 60px;
  `}
`;

const userMenusMomentsStyles = css`
  ${media.minLargeTablet`
    gap: 32px;
  `}
  ${media.minLargeDesktop`
    gap: 60px;
  `}
`;

const userMenusStylesMap: Record<'default' | 'moments', FlattenInterpolation<ThemeProps<DefaultTheme>>> = {
  default: userMenusDefaultStyles,
  moments: userMenusMomentsStyles,
};

const UserMenus = styled.div<{variant: 'default' | 'moments'}>`
  ${flexCenter}
  ${({variant}) => userMenusStylesMap[variant]}
`;

const StyledReorderDropdown = styled(ReorderDropdown)`
  button {
    border: 0;
    ${media.minLargeTablet`
      padding-left: 0;
      padding-right: 0;
    `}
  }
`;

// TODO: move to shared ?
const PageHeaderDefault = ({
  isHardLogoClick = false,
  readOnlyAddress,
  scrollTopOnOpenAddressDropdown,
  showReorderDropdown,
  tenbis4BusinessProps,
  showAddressDropdown,
  isUserLoggedIn,
}: {
  isHardLogoClick?: boolean;
  readOnlyAddress?: boolean;
  scrollTopOnOpenAddressDropdown?: boolean;
  isUserLoggedIn: boolean;
} & HeaderAllowedFeatures) => (
  <HeaderWrapper>
    <Logo isHardLogoClick={isHardLogoClick} />
    <AddressDropdownWrapper isLoggedIn={isUserLoggedIn}>
      {showAddressDropdown && (
        <AddressDropdown
          readOnlyAddress={readOnlyAddress}
          scrollTopOnOpenAddressDropdown={scrollTopOnOpenAddressDropdown}
          isMenuPage={false}
        />
      )}
    </AddressDropdownWrapper>
    <UserMenus variant={tenbis4BusinessProps?.showMoments ? 'moments' : 'default'}>
      {(tenbis4BusinessProps?.show10bis4Business || tenbis4BusinessProps?.showMoments) && (
        <TenbisForBusiness
          isMomentsEnabled={!!tenbis4BusinessProps.showMoments}
        />
      )}
      {showReorderDropdown && <StyledReorderDropdown />}
      <LanguageAndUserMenu isMomentsUser={Boolean(tenbis4BusinessProps?.showMoments || tenbis4BusinessProps?.show10bis4Business)} />
    </UserMenus>
  </HeaderWrapper>
);

export default memo(PageHeaderDefault);
